<template>
  <div> 

<v-snackbar dark v-model="snackbar" :timeout="4000" top>
      <span>You just added a new product goal.</span>
      <v-btn flat color="primary" @click="snackbar = false">Close</v-btn>
    </v-snackbar>


    <v-layout row wrap align-center justify-center class="mt-3">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title> 
               <v-layout row wrap align-center justify-center class="mt-2">
            <span class="headline font-weight-bold">List of the product goals for the solution concept</span> 
              <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                Tip: .
              </v-alert> -->
               </v-layout>
            </v-card-title>
            <v-card-text>

                

              <v-form class="px-1" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->
                    
                <v-spacer></v-spacer>

 <v-container grid-list-md>

                  <v-layout align-center justify-center v-for="(productgoal,index) in productgoals" :key="index">


    <v-flex wrap>
      <v-hover >
 

              <v-card
    class="rounded-card mx-auto"  
    color="#F7C3B1"
    max-width="800"
    slot-scope="{ hover }"
    :class="`elevation-${hover ? 12 : 2}`"    
  >
    <v-card-title>
      <!-- <v-icon
        large
        left
      >
        card_giftcard
      </v-icon> -->
      <span class="title font-weight-light">{{productgoal.productgoaltext}}</span> 
      <!-- Solution: My ToDo (Solution Offering) -->
    </v-card-title>

    <!-- <v-card-text class="headline font-weight-normal">
      A Solution which keeps track of Tasks to be done and manages it through the "Getting things done" (GTD) method.
    </v-card-text> -->

    <!-- <v-card-actions>
      <v-list-tile class="grow"> 
        <v-layout
          align-center
          justify-end
        >
           <v-btn to="/bifdashboard" flat color="primary">View Wireframe</v-btn> 
        </v-layout>
      </v-list-tile>
    </v-card-actions> -->
    <v-card-actions>
      
                        <v-layout 
              justify-end
            >
            <!-- <v-btn to="/bifdashboard" flat icon>
                <v-icon>edit</v-icon>
              </v-btn> 
              <v-btn to="/bifdashboard" flat icon>
                <v-icon>delete</v-icon>
              </v-btn>  -->
              <v-btn flat icon>
                <v-icon>edit</v-icon>
              </v-btn> 
              <v-btn flat icon>
                <v-icon>delete</v-icon>
              </v-btn> 
            </v-layout>
    </v-card-actions> 
  </v-card>
        </v-hover>
    </v-flex>

  </v-layout>

 </v-container>

<Popupaddproductgoals @goaladded="snackbar = true" />
<!-- <v-btn class="mx-2" disabled flat fab>
        <v-icon dark>add</v-icon>
        </v-btn> -->
                 
                <v-spacer></v-spacer>
                
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn flat @click="submit" color="primary" class="mx-2 mt-3">Rank solutions</v-btn> -->
                <v-btn flat to="/dumaddproductfeatures" color="primary" class="mx-2 mt-3"><!-- Head to User Stories --> Go Next</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import Popupaddproductgoals from '../components/Popupaddproductgoals'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {
    Popupaddproductgoals
  },
  data() {
    return { 
      doWe: false,
      productgoals: [],
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      snackbar: false
    }
  },
  methods: {
    submit(){
      //console.log(this.dropdownList[1].isEnabled)
      
//  if(this.$refs.form.validate()) {
//         console.log("Attempt to submit")
//         const project = {

//           projecttitle: this.projecttitle,
//           customerproblemdescription: this.customerproblemdescription,
//           whythisproblem: this.whythisproblem,
//           targetagerange: this.targetagerange,
//           problemdomain: this.problemdomain,
//           additionaldetailforproblem: this.additionaldetailforproblem
//         }

//       //   db.collection('projects').add(project).then(() => {
//       //     console.log("added to db!")
//       //   })
//       // }

//         db.collection('projects').add(project).then(function(docRef) {
//                 console.log("Document written with ID: ", docRef.id);
//             })
//             .catch(function(error) {
//                 console.error("Error adding document: ", error);
//             });
//         }

      this.$router.push('dumaddstoriespainpoints')

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    remainingDetailsToBeAdded(){
      return this.dropdownList.filter(dropdownListElement => {
        return dropdownListElement.isEnabled == false
      })
    }
  },
  created(){
    db.collection('projects').doc(this.getProjectID()).collection('productgoals').onSnapshot(res => {

      const changes = res.docChanges();

      changes.forEach(change => {
        if (change.type === 'added'){
          this.productgoals.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      }) 

    })
    //console.log(this.solutionconcepts)
  }
};
</script>

<style>
.rounded-card{
  border-radius:10px;
}
</style>
